<template>
  <div>
    <span class="chips" v-for="(tag, index) in tags" :key="index" @click="doSearch(tag)">{{ tag }}</span>
    <error-message ref="errorDialog" />
  </div>
</template>

<script>
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    ErrorMessage
  },
  props: {
    tags: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  methods: {
    doSearch(tag) {
      const params = new URLSearchParams();
      params.append("q", tag);

      this.$http
        .get("/v1/graphs/search", {
          params: params
        })
        .then(res => {
          this.$store.commit("setSearchResult", res.data);
          this.$router.push({ name: "search-result" });
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの検索に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
          this.$store.commit("setSearchResult", () => []);
        });
    }
  }
};
</script>
<style scoped lang="scss">
span.chips {
  background: #e0e0e0;
  color: rgba(0,0,0,0.87);
  padding: 2px 12px;
  border-radius: 28px;
  margin: 4px;
  display: inline-block;
}
</style>